const GenericType = ({value}) => {
   const val = value.value ?? value;
   return typeof val !== 'string' && typeof val !== 'number'
      ? JSON.stringify(val)
      : val;
}

export default GenericType;
